"use client";

import { installDomGuard } from "@/lib/dom-guard";

// At module scope, so the guard is in place when this bundle is evaluated,
// before the first update after hydration can need it (`EX-SFX03`, ADR-0108).
// A no-op on the server.
installDomGuard();

/** Rendered once by the locale layout; the work is the import above. */
export function DomGuard() {
  return null;
}
